import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    getShipmentsServiceLevels,
    getShipmentsDayServiceLevels,
    getShipmentsServiceLevelsByTimeframe,
    getShipmentAggregatedCost,
} from '../../helpers';
import {
    serviceLevelsKpisApiResponseSuccess,
    serviceLevelsKpisApiResponseError,
} from './actions';
import { ServiceLevelsKpisActionTypes } from './constants';
import { addToast } from '../actions';

export function* getShipmentsServiceLevelsSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsServiceLevels, query);
        yield put(serviceLevelsKpisApiResponseSuccess(ServiceLevelsKpisActionTypes.GET_SHIPMENTS_SERVICE_LEVELS_REQUEST, response.data));
    } catch (error) {
        yield put(serviceLevelsKpisApiResponseError(ServiceLevelsKpisActionTypes.GET_SHIPMENTS_SERVICE_LEVELS_REQUEST, error));
    }
}

export function* getShipmentsDayServiceLevelsSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsDayServiceLevels, query);
        yield put(serviceLevelsKpisApiResponseSuccess(ServiceLevelsKpisActionTypes.GET_SHIPMENTS_DAY_SERVICE_LEVELS_REQUEST, response.data));
    } catch (error) {
        yield put(serviceLevelsKpisApiResponseError(ServiceLevelsKpisActionTypes.GET_SHIPMENTS_DAY_SERVICE_LEVELS_REQUEST, error));
    }
}

export function* getShipmentsServiceLevelsByTimeframeSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsServiceLevelsByTimeframe, query);
        yield put(serviceLevelsKpisApiResponseSuccess(ServiceLevelsKpisActionTypes.GET_SHIPMENTS_SERVICE_LEVELS_BY_TIMEFRAME_REQUEST, response.data));
    } catch (error) {
        yield put(serviceLevelsKpisApiResponseError(ServiceLevelsKpisActionTypes.GET_SHIPMENTS_SERVICE_LEVELS_BY_TIMEFRAME_REQUEST, error));
    }
}

export function* getShipmentsAggregatedCostSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentAggregatedCost, query);
        yield put(serviceLevelsKpisApiResponseSuccess(ServiceLevelsKpisActionTypes.GET_SHIPMENTS_AGGREGATED_COST_REQUEST, response.data));
    } catch (error) {
        yield put(serviceLevelsKpisApiResponseError(ServiceLevelsKpisActionTypes.GET_SHIPMENTS_AGGREGATED_COST_REQUEST, error));
    }
}

export function* watchGetShipmentsDayServiceLevelsSaga() {
    yield takeLatest(ServiceLevelsKpisActionTypes.GET_SHIPMENTS_DAY_SERVICE_LEVELS_REQUEST, getShipmentsDayServiceLevelsSaga);
}

export function* watchGetShipmentsServiceLevelsSaga() {
    yield takeLatest(ServiceLevelsKpisActionTypes.GET_SHIPMENTS_SERVICE_LEVELS_REQUEST, getShipmentsServiceLevelsSaga);
}

export function* watchGetShipmentsServiceLevelsByTimeframeSaga() {
    yield takeLatest(ServiceLevelsKpisActionTypes.GET_SHIPMENTS_SERVICE_LEVELS_BY_TIMEFRAME_REQUEST, getShipmentsServiceLevelsByTimeframeSaga);
}

export function* watchGetShipmentsAggregatedCostSaga() {
    yield takeLatest(ServiceLevelsKpisActionTypes.GET_SHIPMENTS_AGGREGATED_COST_REQUEST, getShipmentsAggregatedCostSaga);
}

function* serviceLevelsKpisSaga() {
    yield all([
        fork(watchGetShipmentsServiceLevelsSaga),
        fork(watchGetShipmentsDayServiceLevelsSaga),
        fork(watchGetShipmentsServiceLevelsByTimeframeSaga),
        fork(watchGetShipmentsAggregatedCostSaga),
    ]);
}

export default serviceLevelsKpisSaga;
